import React, { useEffect, useState } from 'react';

import { Button, Dialog, Icon, Space } from '@sravni/react-design-system';
import { Filter } from '@sravni/react-icons';
import { useBoolean } from '@sravni/react-utils';

import { FILTER_NAMES } from '../../../../constants/reviews';
import { IListHeaderProps } from '../../index';
import { FilterRegion } from '../FilterRegion';
import { FilterStatus } from '../FilterStatus';
import styles from '../ProductsModal/products-modal.module.scss';
import { Sort } from '../Sort';

interface IProps extends Pick<IListHeaderProps, 'filters' | 'currentServerFilters' | 'typePage' | 'handleChange'> {}

export const MobileFilters: React.FC<IProps> = ({ handleChange, typePage, filters, currentServerFilters }) => {
  const [showModal, setShowModal] = useBoolean(false);
  const [filtersPatch, setActiveFilters] = useState(filters);

  useEffect(() => setActiveFilters(filters), [filters]);

  const handleSubmit = async () => {
    await handleChange(filtersPatch);
    setShowModal.off();
  };

  const handleReset = () => {
    setActiveFilters(filters);
  };

  const handleFilterChange = (value, target) => {
    setActiveFilters((filters) => ({ ...filters, [target]: value }));
  };

  const modal = (
    <Dialog onClose={() => setShowModal.off()} visible={showModal} fullscreen>
      <Dialog.Header title={'Фильтры'} />
      <Dialog.Content className={styles.content}>
        <Sort
          typePage={typePage}
          filters={filtersPatch}
          currentServerFilters={currentServerFilters}
          handleChange={handleFilterChange}
          isPopup
        />
        <FilterStatus
          typePage={typePage}
          filters={filtersPatch}
          currentServerFilters={currentServerFilters}
          handleChange={handleFilterChange}
          isMobile
        />
        <FilterRegion
          locationGarId={filtersPatch[FILTER_NAMES.LOCATION_GAR_ID]}
          handleChange={handleFilterChange}
          isMobile
        />
      </Dialog.Content>
      <Dialog.Footer>
        <Space direction={'vertical'}>
          <Button onClick={handleSubmit} variant={'primary'} color={'dark'} block size={44} className={'h-mt-32'}>
            Показать
          </Button>
          <Button onClick={handleReset} variant={'text'} color={'blue'} block size={36} className={'h-mt-12'}>
            Сбросить фильтры
          </Button>
        </Space>
      </Dialog.Footer>
    </Dialog>
  );

  return (
    <>
      <Space className={styles.mobileButton} align={'center'} justify={'center'} onClick={setShowModal.on}>
        <Icon icon={<Filter />} />
        Фильтры
      </Space>
      {modal}
    </>
  );
};
